import script from "./DynamicVirtualizationList.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicVirtualizationList.vue?vue&type=script&setup=true&lang=js"

import "./DynamicVirtualizationList.vue?vue&type=style&index=0&id=505c4ff4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-505c4ff4"]])

export default __exports__